export function mapInvoiceStatusToBadge(status: string | null): string {
  const normalized = (status ?? "").trim().toLowerCase();

  if (normalized === "autorizada") return "paid";
  if (normalized === "pendente") return "pending";
  if (normalized.includes("process")) return "processing";
  if (
    normalized === "rejeitada" ||
    normalized === "negada" ||
    normalized === "cancelamentonegado"
  ) {
    return "failed";
  }
  if (normalized === "cancelada") return "canceled";

  return "pending";
}

export function invoiceStatusTone(
  status: string | null,
): "success" | "error" | "neutral" {
  const normalized = (status ?? "").trim().toLowerCase();

  if (normalized === "autorizada") return "success";
  if (
    normalized === "rejeitada" ||
    normalized === "negada" ||
    normalized === "cancelada" ||
    normalized === "cancelamentonegado"
  ) {
    return "error";
  }

  return "neutral";
}
